import React from 'react';
import DualAxisChart from '../../charts/DualAxisChart'
import parse from 'date-fns/parse'
import {useTranslation} from "react-i18next";

const CumulatedConsentByDayChart = ({data}) => {
  const { t } = useTranslation();

  const dataToPoint = accessor => elt => ([
    parse(elt.date, 'yyyy-MM-dd', new Date()).getTime(),
    elt[accessor]
  ])

  const dataToPointRate = (numerator, divider) => elt => ([
    parse(elt.date, 'yyyy-MM-dd', new Date()).getTime(),
    100 * elt[numerator]/elt[divider]
  ])

  const dataToChartSeries = (data) => {
    const devices = data.map(dataToPoint("devices"))
    const devicesWithCmpPresented = data.map(dataToPoint("devicesWithCmpPresented"))
    const consentedDevices = data.map(dataToPoint("consentedDevices"))
    const presentationRate = data.map(dataToPointRate("devicesWithCmpPresented", "devices"))
    const consentRate = data.map(dataToPointRate("consentedDevices", "devices"))

    return [
      {
        "name": t("cmp.analytics.metrics.devices"),
        "data": devices,
        "color": "#B2382B",
        "visible": false,
        "type": "areaspline"
      },
      {
        "name": t("cmp.analytics.metrics.devicesWithCmpPresented"),
        "data": devicesWithCmpPresented,
        "color": "#FED3CF",
        "visible": true,
        "type": "areaspline"
      },
      {
        "name": t("cmp.analytics.metrics.consentedDevices"),
        "data": consentedDevices,
        "color": "#FF513C",
        "visible": true,
        "type": "areaspline"
      },
      {
        "name": t("cmp.analytics.metrics.presentationRate"),
        "data": presentationRate,
        "color": "#888888",
        "yAxis": 1,
        "type": "spline",
        "visible": true,
        "tooltip": {
          "valueDecimals": 2,
          "valueSuffix": "%"
        }
      },
      {
        "name": t("cmp.analytics.metrics.consentRate"),
        "data": consentRate,
        "color": "#DDDDDD",
        "yAxis": 1,
        "type": "spline",
        "visible": true,
        "tooltip": {
          "valueDecimals": 2,
          "valueSuffix": "%"
        }
      }
    ]
  }
  const chartData = dataToChartSeries(data);
  return (<DualAxisChart legendOptions={{clickable: true}} series={chartData}/>)
}

export default CumulatedConsentByDayChart
